import nextId from '../../utils/nextId';
import {
  ADDPRODUCT,
  DECREASEPRODUCT,
  INCREASEPRODUCT,
  INCREASEPRODUCTBYVALUE,
} from './actionTypes';
import initialState from './initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // adding new product
    case ADDPRODUCT:
      return [
        ...state,
        {
          id: nextId(state),
          ...action.payload,
        },
      ];

    // increase product quantity
    case INCREASEPRODUCT:
      return state.map((product) => {
        if (action.payload === product.id) {
          return {
            ...product,
            quantity: product.quantity + 1,
          };
        }

        return product;
      });

    // decrease product quantity
    case DECREASEPRODUCT:
      return state.map((product) => {
        if (action.payload === product.id) {
          return {
            ...product,
            quantity: product.quantity - 1,
          };
        }

        return product;
      });

    // increase product quantity by value
    case INCREASEPRODUCTBYVALUE:
      return state.map((product) => {
        if (action.payload.id === product.id) {
          return {
            ...product,
            quantity: product.quantity + action.payload.value,
          };
        }

        return product;
      });
    default:
      return state;
  }
};

export default reducer;
